import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

export const checkAddressRemoval = async (value) => {
  return await request.get(
    '/HousingStock/transport/check_address_removal',
    value,
    'При проверки наличия пропуска по адресу клиента произошла ошибка'
  );
};

const useCheckAddressRemovalQuery = (params, options = {}) =>
  useQuery(
    queryKeys.checkAddressRemoval(params),
    () => checkAddressRemoval(params),
    options
  );

export default useCheckAddressRemovalQuery;
